import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

// Import configs and util modules
import { intlShape, injectIntl, FormattedMessage } from '../../../../util/reactIntl';
import {
  CATEGORY_ACCESSORY,
  CATEGORY_ACCESSORY_OLD,
  CATEGORY_BRIDAL,
  CATEGORY_BRIDAL_GOWNS,
  CATEGORY_GOWNS,
  CATEGORY_SHOE,
  CATEGORY_SHOES,
  propTypes,
} from '../../../../util/types';

// Import shared components
import { Form, Button, FieldTextInput } from '../../../../components';

// Import modules from this directory
import css from './EditListingAppearanceForm.module.css';
import { yearFormatValid } from '../../../../util/validators';
import FieldMultiSelect from '../../../../components/FieldMultiSelect/FieldMultiSelect';

export const EditListingAppearanceFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        formId,
        autoFocus,
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        values,
        productType,
      } = formRenderProps;

      const yearValid = yearFormatValid(
        intl.formatMessage({
          id: 'EditListingAppearanceForm.yearValid',
        })
      );

      const { updateListingError, showListingsError } = fetchErrors || {};

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled =
        invalid ||
        disabled ||
        submitInProgress ||
        ([CATEGORY_GOWNS, CATEGORY_BRIDAL, CATEGORY_BRIDAL_GOWNS].includes(productType) && !values.material) ||
        ([CATEGORY_ACCESSORY, CATEGORY_ACCESSORY_OLD].includes(!productType) && !values.color && !values.color) ||
        ([CATEGORY_GOWNS, CATEGORY_SHOES, CATEGORY_BRIDAL, CATEGORY_BRIDAL_GOWNS, CATEGORY_SHOE].includes(productType) && !values.style) ||
        !values.anyDamage ||
        !values.purchasedYear;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingLocationForm.updateFailed" />
            </p>
          ) : null}

          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingLocationForm.showListingFailed" />
            </p>
          ) : null}

          <div className={css.fieldSelect}>

            {[CATEGORY_GOWNS, CATEGORY_BRIDAL, CATEGORY_BRIDAL_GOWNS].includes(productType) && (<div>
              <label><FormattedMessage id="EditListingAppearanceForm.material" /></label>
              <FieldMultiSelect
                isMulti={false}
                isRequired={true}
                className={css.input}
                id={'material'}
                name={'material'}
                fontClass={css.fontClass}
                options={[]}
                autoComplete={'material'}
                defaultValue={values?.material || ''}
              // validate={subCategoryRequired}
              />
            </div>)}

            {[CATEGORY_ACCESSORY, CATEGORY_ACCESSORY_OLD].includes(!productType) && (<div>
              <label><FormattedMessage id="EditListingAppearanceForm.color" /></label>
              <FieldMultiSelect
                isMulti={false}
                isRequired={true}
                className={css.input}
                id={'color'}
                name={'color'}
                fontClass={css.fontClass}
                options={[]}
                autoComplete={'color'}
                defaultValue={values?.color || ''}
              // validate={subCategoryRequired}
              />
            </div>)}
          </div>

          <div className={css.fieldSelect}>

            {[CATEGORY_GOWNS, CATEGORY_SHOES, CATEGORY_BRIDAL, CATEGORY_BRIDAL_GOWNS, CATEGORY_SHOE].includes(productType) && (<div>
              <label><FormattedMessage id="EditListingAppearanceForm.style" /></label>
              <FieldMultiSelect
                isMulti={false}
                isRequired={true}
                className={css.input}
                id={'style'}
                name={'style'}
                fontClass={css.fontClass}
                options={[]}
                autoComplete={'style'}
                defaultValue={values?.style || ''}
              // validate={subCategoryRequired}
              />
            </div>)}

            <FieldTextInput
              id="anyDamage"
              name="anyDamage"
              label={intl.formatMessage({ id: 'EditListingAppearanceForm.anyDamage' })}
              className={css.fieldPurchasedSelect}
            />
          </div>


          <FieldTextInput
            id="purchasedYear"
            name="purchasedYear"
            label={intl.formatMessage({ id: 'EditListingAppearanceForm.purchasedYear' })}
            validate={yearValid}
            className={css.fieldPurchasedSelect}
          />

          <br />
          {/* <br /> */}
          {submitDisabled ? <span className={css.error}>
            <FormattedMessage id="EditListingTermsOfSaleForm.errorText" values={{ TabName: <b>Appearance</b> }} />
          </span> : null}
          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingAppearanceFormComponent.defaultProps = {
  selectedPlace: null,
  fetchErrors: null,
  formId: 'EditListingAppearanceForm',
};

EditListingAppearanceFormComponent.propTypes = {
  formId: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  selectedPlace: propTypes.place,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingAppearanceFormComponent);
